import http from "../http-common";
import { AxiosResponse } from "axios";
import {
  ArticleCount,
  DateRange,
  KeywordSearchResult
} from "@/services/CategoriesDataService";

class KeywordsDataService {
  getKeywordComparisonArticles(
    keywordIds: Keyword[]
  ): Promise<AxiosResponse<KeywordComparisonArticles>> {
    const url = `/keyword-comparison-articles?ids=${JSON.stringify(
      keywordIds
    )}`;
    return http.get<KeywordComparisonArticles>(url);
  }

  getKeywordComparisonCoOccurring(
    keywordIds: Keyword[],
    dateRange: DateRange
  ): Promise<AxiosResponse<KeywordComparisonCoOccurringResponse>> {
    const url = `/keyword-comparison-cooccurring?ids=${JSON.stringify(
      keywordIds
    )}&dateRange=${JSON.stringify(dateRange)}`;
    return http.get<KeywordComparisonCoOccurringResponse>(url);
  }

  getKeywordComparisonCategories(
    keywordIds: Keyword[],
    dateRange: DateRange
  ): Promise<AxiosResponse<KeywordComparisonResponse>> {
    const url = `/keyword-comparison-categories?ids=${JSON.stringify(
      keywordIds
    )}&dateRange=${JSON.stringify(dateRange)}`;
    return http.get<KeywordComparisonResponse>(url);
  }

  getKeywordComparisonSubcategories(
    keywordIds: Keyword[],
    dateRange: DateRange
  ): Promise<AxiosResponse<KeywordComparisonSubcategoryResponse>> {
    const url = `/keyword-comparison-subcategories?ids=${JSON.stringify(
      keywordIds
    )}&dateRange=${JSON.stringify(dateRange)}`;
    return http.get<KeywordComparisonSubcategoryResponse>(url);
  }

  getKeywordComparisonJournals(
    keywordIds: Keyword[],
    dateRange: DateRange
  ): Promise<AxiosResponse<KeywordComparisonResponse>> {
    const url = `/keyword-comparison-journals?ids=${JSON.stringify(
      keywordIds
    )}&dateRange=${JSON.stringify(dateRange)}`;
    return http.get<KeywordComparisonResponse>(url);
  }

  getKeywordComparisonDocuments(
    keywordIds: Keyword[],
    dateRange: DateRange
  ): Promise<AxiosResponse<KeywordComparisonResponse>> {
    const url = `/keyword-comparison-documents?ids=${JSON.stringify(
      keywordIds
    )}&dateRange=${JSON.stringify(dateRange)}`;
    return http.get<KeywordComparisonResponse>(url);
  }

  getKeywordComparisonLanguages(
    keywordIds: Keyword[],
    dateRange: DateRange
  ): Promise<AxiosResponse<KeywordComparisonResponse>> {
    const url = `/keyword-comparison-languages?ids=${JSON.stringify(
      keywordIds
    )}&dateRange=${JSON.stringify(dateRange)}`;
    return http.get<KeywordComparisonResponse>(url);
  }

  getKeywordsMatchingSearch(
    keywordSearch: string
  ): Promise<AxiosResponse<KeywordSearchResult[]>> {
    const url = `/keyword-search/${keywordSearch}`;
    return http.get<KeywordSearchResult[]>(url);
  }
}

export interface Keyword {
  id: string;
  field: string;
  generic: boolean;
}

export interface KeywordComparisonArticles {
  keywords: [
    {
      keyword: Keyword;
      values: ArticleCount[];
    }
  ];
}

export interface KeywordComparisonResponse {
  keywords: [
    {
      keyword: Keyword;
      values: KeywordViewDataRow[];
    }
  ];
}

export interface KeywordComparisonCoOccurringResponse {
  keywords: [
    {
      keyword: Keyword;
      values: CoOccurringKeywordsForKeywordRow[];
    }
  ];
  union: CoOccurringKeywordsForKeywordRow[];
}

export interface CoOccurringKeywordsForKeywordRow extends KeywordViewDataRow {
  generic: boolean;
}

export interface KeywordViewDataRow {
  id: string;
  field: string;
  amount: number;
}

export interface KeywordComparisonSubcategoryResponse {
  keywords: [
    {
      keyword: Keyword;
      values: KeywordViewSubcategoryDataRow[];
    }
  ];
}

export interface KeywordViewSubcategoryDataRow extends KeywordViewDataRow {
  parentId: string;
}

export default new KeywordsDataService();
